export default {
	default:{
		submit:"Submit",
		SendVerificationCode:"Send",
		VerificationCode:"Verification Code",
		VerificationCodeTip:"Please enter your Verification Code",
		MessageAuthenticationCode:"Message Authentication Code",
		EmailAuthenticationCode:'Email Authentication Code',
		PasswordsNotMatch:"Passwords don't match",
		PasswordChangeSuccess:"Password has been changed",
		PasswordError:"Incorrect Password",
		CNY:'CNY',
		USD:'USD',
		TRY:'TRY',
		Notice:"Reminder",
		Done:'Yes',
		ErrorSendingEmail:'Error in sending E-mail authentication code, please check your E-mail.',
		SuccessSendingEmail:'E-mail authentication code has been sent, please check it.',
		ErrorSendingMessage:'Error in sending message authentication code, please check your phone number.',
		SuccessSendingMessage:'Message authentication code has been sent, please check it.',
		Resend:'Resend',
		EmailCodeErr:'Email verification code error',
		ImgCodeErr:'Image verification code error',
		MessageCodeErr:'SMS verification code error'
	},
	nav:{
		UserCenter:'User Center',
		MyAccount:'My Account',
		SecurityCenter:'Security Center',
		ChangePassword:'Change Password',
		RealNameAuthentication:'Real-name Authentication',
		Phone:'Mobile Phone binding and Changing',
		Email:'Email binding and Changing',
		SecurityQuestion:'Security Question',
		VoucherCenter:'Voucher Center',
		GameRecharge:'Game recharge',
		RechargeHistory:'Recharge History',
		AccountComplaint:'Account complaint',
		ThirdAccount: 'Third-party account'
	},
	header:{
		Login:"Login",
		Logout:"Logout",
		GameLists:"Game Lists",
		UserCenter:"User Center",
		SecurityCenter:"Security Center",
		VoucherCenter:"Voucher Center",
		CustomerServiceCenter:"Customer Service",
		Language:"Language",
		CurrentPosition:"Current Position",
	},
	games:{
		battleTeams1:"battleTeams1",
		battleTeams2:"battleTeams1", 
		battleTeamsMobile:"battleTeamsMobile",
	},
	home:{
		AccountInformation:"Account Information",
		UserName:"User Name",
		Nickname:"Nickname",
		TheLatestLoginDate:"The Latest Login Date",
		SecurityLevel:"Security Level",
		SecurityTip:"For account security, we recommend that you enable the following settings",
		Change:"Change",
		Bind:"Bind",
		Setting:"Setting",
		Submitted:"Submitted",
		Bound:"Bound",
		Set:"Set",
		Unsubmitted:"Unsubmitted",
		Unbound:"unbound",
		Notset:"not set",
		PasswordLevel:"Password Level",
		Security:"Security",
		SecurityLow:'Normal',
		SecurityHigh:'High',
		PasswordLevelLow:"Your password is not safe and it is recommended to modify it",
		PasswordLevelHigh:"Your password is higher security",
		PersonalInformation:"Personal Information",
		RealNameTip:"It is mainly used for anti-addiction authentication and is an important certificate for account appeal",
		MobilePhonebinding:"Mobile Phone binding",
		SecurityQuestionTip:"Help to set important functions such as passwords reset",
		Emailbinding:"Email binding",
		SecurityQuestion:"Security Question",
		NicknameTip:'Please enter your Nickname',
		NicknameSet:'Nickname has been set'
	},
	password:{
		ChangePassword:"Change Password",
		CurrentPassword:"Current Password",
		CurrentPasswordTip:"Please enter your current password",
		NewPassword:"New Password",
		NewPasswordTip:"Please enter your new password",
		ConfirmPassword:"Confirm Password",
		ConfirmPasswordTip:"Please enter your new password again",
		ForgotPassword:"Forgot your password?",
		PasswordsNotMatch:"Passwords don't match",
		PasswordChangeSuccess:"Password has been changed",
		OldPasswordError:"Incorrect password",
		NewPasswordSameAsOldPassword:"New password should not be consistent with the old one.",
		SetPassword:'Set the password'
	},
	forgot:{
		RecoverPassword:"Recover Password",
		RecoverPasswordTip:"You can retrieve your password through the following three ways. If there is any other problem， Please contact our customer support staff immediately",
		SecurityMobilePhone:"Security Mobile Phone",
		SecurityEmail:"Security Email",
		SecurityQuestion:"Security Question",
		UserName:"User Name",
		SecurityQuestion:"Security Question",
		SecurityAnswer:"Security Answer",
		SecurityAnswerTip:"Please enter your security answer",
		SecurityAnswerError:"Incorrect Security Answer",
		NewPassword:"New password",
		NewPasswordTip:"Please enter your new password",
		ConfirmPassword:"Confirm Password",
		NewPasswordAgainTip:"Please enter your new password again",
		PhoneTip:"Please enter your mobile phone number",
		VerificationCode:"Verification Code",
		VerificationCodeTip:"Please enter the Verification Code",
		SendVerificationCode:"Send Verification Code",
		EmialTip:"Please enter your Email",
		Confirmation:"Confirmation",
		PasswordsNotMatch:"Passwords don't match",
		PasswordChangeSuccess:"Password has been changed",
		NotBoundPhone:"You haven't bound Mobile Phone",
		NotBoundEmail:"You haven't bound Email",
		NotSetQuestion:"You haven't set Security Question",
	},
	realName:{
		Name:"Name",
		NameTip:"Please enter your real name",
		IDCard:"ID card",
		IDCardTip:"Please enter your ID card",
		SetRealnameSuccess:"Authenticate information successfully",
		ModifyTip:'If you want to change your real-name information, please contact the Customer Service',
		ReCertification:'ReCertification',
		SetRealnameFail:'Authentication failed, please enter matching personal information',
		MisMatch:'Authentication information does not match, please re-enter'
	},
	phone:{
		MobilePhonebinding:"Mobile Phone binding",
		MobilePhoneNumber:"Mobile Phone Number",
		MobilePhoneNumberTip:"Please enter your Mobile Phone Number",
		VerificationCode:"Verification Code",
		VerificationCodeTip:"Please enter your Verification Code",
		SuccessTip:"Mobile phone binding status: ",
		BoundtoMobilephone:"Bound to Mobile phone",
		ChangetheMobilephone:"Change the Mobile phone",
		UnbindtheMobilephone:"Unbind the Mobile phone",
		Phonelossorabnormity:"Phone loss or abnormity?",
		MessageAuthenticationCode:"Message Authentication Code",
		NewBindPhone:'New bound phone',
		BindingNewPhone:'Bind a new phone',
		Next:'Next',
		CheckOldPhone:'Verify the original phone',
		HadBindOther:'The mobile phone has been bound to another account',
		PleaseCheckOldPhone:'Please verify your original phone number first'
	},
	email:{
		Email:'Email',
		EmailTip:"Please enter your email",
		Emailbinding:"Email binding",
		SuccessTip:"Email bingding status: ",
		BoundtoEmail:"Bound to Email",
		ChangetheEmail:"Change the Email",
		UnbindtheEmail:"Unbind the Email",
		Emaillossorabnormity:"Email loss or abnormity",
		UnbindingEmailSuccessfully:"Unbinding Email successfully",
		EmailFormat:'E-mail format is not correct'
	},
	question:{
		SecurityQuestion:"Security Question",
		SecurityAnswer:"Security Answer",
		SecurityAnswerTip:"Please enter your security answer",
		ConfirmAnswer:"Confirm your answer",
		ConfirmAnswerTip:"Please enter your security answer again",
		VerificationCodeError:'Incorrect Verification Code',
		SetQuestionSuccess:"Security question has been set",
		QuestionNotMatch:"Answers don't match",
		AnswerLength:'The answer should be fewer than 40 letters',
	},
	complaint:{
		ComplaintCon:"If you can't reset your information through your security phone or E-mail, you can send an E-mail to the official E-mail kf@wooduan.com. The E-mail should contain: your ID number (the one you used in Real-name Authentication), 2-3 recharging records, or other information related to your account. And our team will deal with your complaint in 3-7 working days, and send the result to your E-mail."
	},
	charge:{
		OnlineBank:"Online Bank",
		RechargeAccount:"Recharge Account",
		ChoseGame:"Game",
		ChoseServer:"Server",
		ServerSlt:"Select your game and server location!",
		RechargeAmount:"Recharge Amount",
		AmountTip:"Other",
		BanksTip:"Please choose one of the following banks",
		MoreBanks:"More Banks",
		Overview:"Overview",
		Game:"Game",
		Server:"Server",
		Price:"Price",
		Confirmthepayment:"Confirm the payment",
		SuccessTip:"Congratulations， top up successfully",
		OrderInformation:"Order Information",
		TopupGame:"Top-up game",
		Rechargeserver:"Recharge server",
		Paymentmethod:"Payment method",
		TotalrechargeAmount:"Total recharge Amount",
		Topupagain:"Top up again",
		RechargeHistory:"Recharge History",
		GoldAmount:"{gold} Gold",
		MoneyAmount:"USD {money}",
		PayWithWeixin:'Top up by scanning Wechat QR code',
		TopupSuccessfully:"Top up successfully",
		TopupProblems:"Problems encountered in recharging",
		ChoseAmount:"Select your recharge amount",
		ChoseGameAndRegion:"Select your game and server location",
		ChoseChargeType:"Select a recharge method",
		TopupFailTip:'Fail to top up, please submit again',
		TopupFailNeedService:"Fail to top up, please contact with Customer Service {msg}",
		OrderNumber:'Order Number',
		RedeemCode:'Redeem Code',
		Topup:'Top up',
		ConfirmThePayment:'Confirm the payment',
		TenAmount:'Customize the recharging amount（Please enter a multiple of 10）',
		Unknown:'Unknown',
		Unpaid:'Unpaid',
		Recharging:'Recharging',
		RechargeSuccessful:'Recharge successful',
		RechargeFailed:'Recharge failed',
		CancelTheRecharge:'Cancel the recharge',
		Refunded:'Refunded',
		CancelTheRefund:'Cancel the refund',
		RefundFailed:'Refund failed',
		Refunding:'Refunding',
		NewOrder:'New order',
		StyleDeal:'Pending',
		Dealing:'Processing',
		Expired:'Expired',
		Checking:'Under review',
		Provider:'Payment Provider',
		Terms:'Please check the terms of service'
	},
	chargeHistory:{
		LastWeek:"Last Week",
		LastMonth:"Last Month",
		HistoricalRecharge:"Historical Recharge",
		QueryRange:"Query Range",
		Selectgames:"Select games",
		Pleaseselectagame:"Please select a game",
		Inquire:"Inquire",
		Time:"Time",
		Account:"Account",
		GameServer:"Game Server",
		Paymentmethod:"Payment method",
		PaymentAmount:"Payment Amount",
		Status:"Status",
		Totalamount:"Total amount of recharge",
		Totalitems:"Total {items} items",
	},
	login:{
		Login:"Wooduan Passes Login",
		AccountLabel:"User Name/Mobile Phone Number/Email",
		PasswordLabel:"Password",
		ConfirmPassword:'Confirm Password',
		ConfirmPasswordLabel:'Confirm Password',
		LoginBtn:"Login now",
		RegisterBtn:'Sign Up Now',
		RegisterLink:"No Account? Register now",
		LoginLink:'Already registered? Click to Login',
		ForgotLink:"Forgot password",
		QuickLogin:"Quick Login",
		Register:'Wooduan Passes Registration',
		RecoverByPhone:"Recover your password by Security Mobile",
		RecoverByQuestion:"Recover your password by Security Question",
		RecoverByEmail:"Recover your password by Security Email",
		Phone:"Mobile Phone Number",
		UserName:"User Name",
		ResetPassword:"Reset Password",
		RecoverByOther:"Recover your password by other methods",
		SecurityEmail:"Security Email",
		SecurityQuestion:'Security Question',
		SecurityAnswer:'Security Answer',
		PhoneAccountTip:'Please enter your user name or mobile phone',
		PasswordTip:'Please enter your password',
		PhoneNotReged:'This mobile phone has never been registered',
		AccountNotReged:'This user name has never been registered',
		LoginFail:'Fail to log in, please log in again',
		RegSuccess:'Sign in successfully, please log in',
		PhonwHasReged:'This mobile phone has already been registered',
		AccountHasReged:'This user name has already been registered',
		RegFail:'Fail to sign in, please submit again',
		EmailHasReged:'This mail has already been registered',
		PasswordErr:'Password must contain at least one number or letter, 6-16 digits',
		AccountErr:'User name must start with English letters, excluding Chinese, 4-18 digits',
		RegAccountTip:'Enter username',
	},
	third:{
		RemoveBound: 'Remove binding',
     	UnbindSuccess: 'Unbind Success',
     	ThirdAccountTip: 'You can bind or unbind the third-party accounts, and use the third-party account to quickly log in after binding',
	},
	bind:{
		head:'Bind to account',
        tip:'Please bind your user name/phone/E-mail to your account',
        bind:'Bind now',
		or:'Or',
		bindErr:'Binding failed, please try later',
		confirm:'Confirm',
		cancel:'Cancel',
		return:'return',
		PhonwHasReged:'This mobile phone has already been registered',
		AccountHasReged:'This user name has already been registered',
		VerificationCodeError:'Incorrect Verification Code',
		EmailHasReged:'This mail has already been registered',
		ErrorSendingEmail:'Error in sending E-mail authentication code, please check your E-mail.',
		ErrorSendingMessage:'Error in sending message authentication code, please check your phone number.',
		ParamErr:'Parameter error',
		auto:'Generate an account automatically',
		user:'User Name',
		password:'Password',
		noAccount:'No Account, register now',
		hasAccount:'Already registered, click to bind',
		regHead:'Register',
		regTip:'Please fill out the registration information',
		confirm_password:'Confirm your password',
		email:'E-mail',
		phone:'Mobile Phone Number',
		emailCode:'E-mail verification code',
		phoneCode:'Mobile phone verification code',
		getCode:'Get verification code',
		retry:'Retry',
		submit:'Register now', 
		accountTip:'Please enter your account',
        passwordTip:'Please enter your password',
        passwordErr:'Invalid password format. The password should contain 6-16 digits with at least one number or letter in it, and it should not contain any special characters',
        confirmTip:'Entered passwords differ from the another',
        phoneTip:'Please enter your mobile phone number',
        emailTip:'Please enter your E-mail',
        phoneErr:'Invalid Mobile phone number format',
        emailErr:'Invalid email address format',
        codeTip:'Please enter verification code',												               		                
	}
}